import { connect } from 'react-redux';
import { modalErrorOpen } from '../../../store/actions/modalError';
import { getSemiProducts } from '../../../store/actions/semiProducts';
import { deleteUndercut, getUndercutList, getUndercutOperation, getUndercutTypesList, saveUndercut } from '../../../store/actions/undercut';
import SavedProductsTable from './UndercutInputTab';

const mapStateToProps = ({
  userReducer,
  semiProductsReducer,
  tabsReducer,
  undercutReducer,
  savedProductsReducer
}) => ({
  userReducer,
  semiProductsReducer,
  tabsReducer,
  undercutReducer,
  savedProductsReducer

});
const mapDispatchToProps = {
  getSemiProducts,
  getUndercutList,
  getUndercutOperation,
  getUndercutTypesList,
  saveUndercut,
  deleteUndercut,
  modalErrorOpen
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SavedProductsTable);
